import { useIntl } from 'gatsby-plugin-react-intl';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

import ScrollUpButton from '../ScrollUpButton';

import { BackgroundImage, BackToTopWrapper } from './styles';

const BackToTop = ({ duration = 1000, visible = null }) => {
  const intl = useIntl();
  const [pageHeight, setPageHeight] = useState(1000);

  useEffect(() => {
    setPageHeight(document.body.scrollHeight * 0.6);
  }, []);

  return (
    <BackToTopWrapper className={visible}>
      <ScrollUpButton
        ContainerClassName="buttonTop"
        TransitionClassName="buttonTopAnimate"
        ShowAtPosition={pageHeight}
        AnimationDuration={duration}
      >
        <BackgroundImage />
        <p>{intl.locale === 'en' ? 'Back up' : 'Remonter'}</p>
      </ScrollUpButton>
    </BackToTopWrapper>
  );
};

BackToTop.propTypes = {
  duration: PropTypes.number,
  visible: PropTypes.string,
};

export default BackToTop;
